import React from "react";
import { Controller } from "react-hook-form";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Stack,
  Typography,
  FormHelperText,
  Avatar,
} from "@mui/material";
import { MedicalServices, LocationOn } from "@mui/icons-material";

const DoctorCardField = ({ name, control, doctors, handleNext }) => {
  // console.log("dcot = ", doctors);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <>
          {doctors.map((doctor) => (
            <Grid item xs={12} sm={6} lg={3} key={doctor._id}>
              <Card
                elevation={0}
                sx={(theme) => ({
                  border:
                    value === doctor._id
                      ? `2px solid ${theme.palette.secondary.main}`
                      : "1px solid #ddd",
                  backgroundColor:
                    value === doctor._id
                      ? theme.palette.secondary.main + "10"
                      : "#fff",

                  // ✅ ensure all cards same height
                  height: 220, // adjust as needed
                  maxWidth: 300,
                  p: 2,
                  textAlign: "center",
                  borderRadius: 3,
                  cursor: "pointer",
                })}
                onClick={() => {
                  onChange(doctor._id);
                  handleNext();
                }}
              >
                <CardContent>
                  <Stack alignItems="center">
                    <Avatar
                      src={doctor?.image}
                      alt={doctor?.name}
                      sx={(theme) => ({
                        width: 90,
                        height: 90,
                        mb: 2,
                        bgcolor:
                          value === doctor._id
                            ? "white"
                            : theme.palette.secondary.main + "10",
                        // border:
                        //   value === doctor._id &&
                        //   `1px solid ${theme.palette.secondary.main}`,
                        // bgcolor: "white",
                        // bgcolor: theme.palette.secondary.main + "10",
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "secondary.main",
                      })}
                    >
                      {!doctor?.image &&
                        doctor?.name
                          ?.split(" ")
                          .map((n) => n[0])
                          .slice(0, 2)
                          .join("")
                          .toUpperCase()}
                    </Avatar>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        maxWidth: "100%",
                        display: "-webkit-box",
                        WebkitLineClamp: 2, // limit to 2 lines
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        wordBreak: "break-word", // handles long single words
                      }}
                    >
                      {doctor?.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      // noWrap // prevents breaking into multiple lines
                      // sx={{ maxWidth: "100%" }}
                      sx={{
                        maxWidth: "100%",
                        display: "-webkit-box",
                        WebkitLineClamp: 2, // limit to 2 lines
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        wordBreak: "break-word", // handles long single words
                      }}
                    >
                      {doctor?.speciality}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
              {/* <Card
                elevation={0}
                // boxShadow="none"
                sx={(theme) => ({
                  border:
                    value === doctor._id
                      ? `2px solid ${theme.palette.secondary.main}`
                      : "1px solid #ddd",
                  backgroundColor:
                    value === doctor._id
                      ? theme.palette.secondary.main + "10"
                      : "#fff",
                  // display: "flex",
                  height: "100%", // uniform height
                  minHeight: 80, // 🔑 make all cards at least same height

                  cursor: "pointer",
                })}
                onClick={() => onChange(doctor._id)}
              >
                <CardMedia
                  component="img"
                  image={doctor?.img || "/profile5.png"}
                  alt="doctor"
                  sx={{
                    // width: 120,
                    height: 80, // 🔑 force fixed height
                    objectFit: "contain", // keeps image proportional & crops overflow

                    bgcolor: "#fafafa",
                    borderBottom: "2px solid #eee",
                  }}
                />
                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    overflow: "hidden",
                    // bgcolor: "#f9f9f9",
                    px: 1,
                    py: "8px !important",
                  }}
                >
                  <Typography
                    // gutterBottom
                    variant="h6"
                    component="div"
                    sx={{
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                      textOverflow: "unset",
                      lineHeight: 1,
                    }}
                  >
                    {doctor?.name}
                  </Typography>


                  <Typography variant="body2" color="text.secondary">
                    {doctor?.speciality}
                  </Typography>

                 
                </CardContent>
              </Card> */}
            </Grid>
          ))}

          {/* ✅ Only one error shown */}
          {error && (
            <FormHelperText error sx={{ fontSize: "0.9rem", mt: 1 }}>
              {error.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  );
};

export default DoctorCardField;
